import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = `Public|Verify|Credential`;

const sharedProps: Pick<LocDef, 'portal' | 'shared' | 'htmlAllowed'> = {
	portal: 'CP',
	shared: false,
	htmlAllowed: false,
};

export type VerifyCertLoc = 'CPVerifyCertANSICriteria';

export const cpVerifyCertLocs: LocDefs<VerifyCertLoc> = {
	CPVerifyCertANSICriteria: {
		defaultValue: 'ANSI Criteria',
		description: 'Label for the ANSI criteria.',
		displayPath: `${dpRoot}|ANSI Criteria`,
		displayType: 'Label',
		feature: HubFeature.ExamComptiaAnsiCriteria,
		...sharedProps,
	},
};

export const VerifyCertLocKeys = MapLocKeys<VerifyCertLoc>(cpVerifyCertLocs);
export type VerifyCertLocKey = typeof VerifyCertLocKeys;
